import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import UserTable from '../../../components/tables/UserTable';

const generateSampleData = (count = 60) => {
  const statuses = ['Active', 'Inactive'];
  const cities = [
    'Pune',
    'Nagpur',
    'Nashik',
    'Aurangabad',
    'Kolhapur',
    'Solapur',
    'Thane',
    'Satara',
    'Jalgaon',
    'Sangli'
  ];

  return Array.from({ length: count }, (_, index) => {
    const joinDate = new Date(
      2022 + Math.floor(Math.random() * 3),
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1
    )
      .toISOString()
      .split('T')[0];

    return {
      id: `RTL${String(index + 1).padStart(4, '0')}`,
      limit: Math.floor(Math.random() * 25000) + 5000,
      name: `Retailer ${index + 1}`,
      email: `retailer${index + 1}@paynet.in`,
      phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      city: cities[Math.floor(Math.random() * cities.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      joinDate
    };
  });
};

const formatCurrency = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return '-';
  }
  return `₹${amount.toLocaleString('en-IN')}`;
};

const UserManagementRetailer = () => {
  const [retailerData, setRetailerData] = useState(() => generateSampleData());

  const handleDataChange = (updatedData) => {
    setRetailerData(
      updatedData.map((item) => ({
        ...item,
        limit:
          item.limit !== undefined && item.limit !== null
            ? item.limit
            : Math.floor(Math.random() * 25000) + 5000,
      }))
    );
  };

  return (
    <Container fluid>
      <UserTable
        data={retailerData}
        userRole="Retailer"
        onDataChange={handleDataChange}
        extraColumns={[
          {
            key: 'limit',
            label: 'Limit (₹)',
            render: (row, value) => formatCurrency(value),
          },
        ]}
        allowAdd={false}
        allowEdit={false}
        allowExport={false}
      />
    </Container>
  );
};

export default UserManagementRetailer;

